import React, { useEffect,  type ReactNode  } from "react";
import Container from "../Container";
import closeIcon from "../../assets/icon/close-icon.svg";
import "./index.scss";


type Props = {
	isOpen: boolean; // true または false で指定可能
	onClose: () => void;
	children: ReactNode;
  style?: React.CSSProperties;
  className?:string;
};

const Modal : React.FC<Props> = ({ className,isOpen, onClose, children ,style }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);
  return (
    <div className="modal-overlay" onClick={onClose} style={style}>
      <Container>
        <div className={`modal-content ${className}`} onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
          {children}
          <button
            className="modal-close-btn noto-sans-jp-semibold"
            onClick={onClose}
          >
            <img src={closeIcon} alt="Close" />
            <p style={{fontWeight:"400"}}>閉じる</p>
          </button>
        </div>
      </Container>
    </div>
	);
};

export default Modal;
